const header = document.querySelector('.header')
const navMenuButton = document.querySelector('.menu-btn')
const navOverlay = document.querySelector('.header__overlay')

let scrollYPos = 0
let initialPosition = ''
let initialOverflowY = ''

function openNav() {
  //Add open class
  header.classList.add('header--nav-open')

  //Prevent body scroll

  // get the initial values because IE11 doesn't know "initial", and I don't just want to set to "auto"
  initialPosition = document.body.style.position
  initialOverflowY = document.body.style.overflowY

  scrollYPos = document.documentElement.scrollTop
  document.body.style.top = -1 * scrollYPos + 'px'
  document.body.style.position = 'fixed'
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.overflowY = 'scroll'
}

function closeNav() {
  //Remove open class
  header.classList.remove('header--nav-open')

  //Enable body scroll
  // just in-case someone else set them. You could pretty safely in this case just set to "", but you never know
  document.body.style.position = initialPosition
  document.body.style.overflowY = initialOverflowY
  window.scrollTo(0, scrollYPos)
}

navMenuButton.addEventListener('change', () => {
  header.classList.contains('header--nav-open') ? closeNav() : openNav()
})

navOverlay.addEventListener('click', closeNav)
